module.exports = __webpack_public_path__ + "static/media/0022.99a29a66.png";